import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import App from "./App.vue";
import router from "./router";
import pinia from "./stores";

import "@/assets/styles/element-theme.scss";
import "@/assets/styles/fullcalendar.scss";
import "@/assets/styles/tutor-spacing.scss";
import "@/assets/styles/tutor-ui.scss";
import { setupDialogBounce } from "@/utils/dialogBounce";

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(ElementPlus);

app.mount("#app");
setupDialogBounce();
